export const TACK_INTERVAL_SELECTION_ERROR = 'tack_interval_selection.ERROR';
export const TACK_INTERVAL_SELECTION_LOADING = 'tack_interval_selection.LOADING';
export const TACK_INTERVAL_SELECTION_SELECTED = 'tack_interval_selection.SELECTED';
export const TACK_INTERVAL_SELECTION_RESET = 'tack_interval_selection.RESET';
export const TACK_INTERVAL_SELECTION_OPTIONS_LOADING = 'tack_interval_selection_options.LOADING';
export const TACK_INTERVAL_SELECTION_OPTIONS_LOADED = 'tack_interval_selection_options.LOADED';
export const TACK_INTERVAL_SELECTION_OPTIONS_RESET = 'tack_interval_selection_options.RESET';



// WEBPACK FOOTER //
// ./src/stores/tack_interval_selections/action_types.js